<template>
    <v-dialog v-model="viewSessionModal" max-width="600px" content-class="book-modal" :fullscreen="$vuetify.breakpoint.xs ? true : false">
        <v-card>
            <div class="modal-header">
                <v-btn v-if="step > 1" @click="goBack(step)" icon class="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <h4 class="modal-headline">
                    {{ modalTitle }}
                </h4>
                <div class="tools"> 
                    <v-btn icon @click="viewSessionModal = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </div>
            <div style="min-height:400px">
            
            <v-card-text v-if="step == 1">
                    <v-row > 
                        <v-col v-if="sessions.length != 0" cols="12" class="sessions-list">
                            <div v-for="session in sessions" :key="session.id" @click="goToStep2(session)" class="rounded session-box" :style="{borderLeftColor: session.color}">
                                <ul>
                                    <li class="title">{{session.title}}</li>
                                    <li>{{session.duration}} min</li>
                                </ul>                             
                            </div>
                        </v-col>
                    </v-row>
            </v-card-text>

            <v-card-text v-if="step == 2">
                <div v-if="classBooking == true">
                    <v-list v-for="appointment in groupAppointments" :key="appointment.day">
                        <v-subheader>{{appointment.day}}</v-subheader>
                        <v-list-item-group>
                            <template v-for="(item, index) in appointment.data">
                                <v-list-item  :key="item.id" @click="goToReview(item)" :disabled="!item.can_book">
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title><b>{{item.start | formatTime}} {{item.title}}</b></v-list-item-title>
                                            <v-list-item-subtitle >{{item.booked_seats}} od {{item.max_seats}} - {{item.trainer.full_name}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider></v-divider>
                            </template>
                        </v-list-item-group>
                    </v-list>
                    <v-card-text v-if="groupAppointments.length == 0" class="text-center font-weight-light text--disabled">{{ $page.props.lang.no_available_appontments || "There is no available appointments for this activity"}}</v-card-text>
                </div>

                <div v-if="!classBooking">
                    <v-list-item-group>
                        <v-list>
                            <v-list-item v-for="trainer in trainers" :key="trainer.id" @click="selectTrainer(trainer)">
                                <v-list-item-avatar>
                                    <v-img :src="trainer.profile_photo_url+'?w=40'"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title v-text="trainer.full_name"></v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-list-item-group>
                </div>
            </v-card-text>
            <div v-if="step == 3">
                <v-card-text>
                    <div class="class-info">
                        <h3 class="mb-1">{{currentSession != null ? currentSession.title : ""}}</h3>
                        <span>
                            <v-avatar size="28" class="mr-1"><img :src="selected.appointment.trainer.profile_photo_url+'?w=56'"></v-avatar>
                            {{selected.appointment.trainer.full_name}}
                        </span><br>
                        <span>Trajanje: {{selected.activity.duration}} minuta</span>
                    </div>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-date-picker 
                                v-model="selectedDate" 
                                @change="changeDate"
                                :min="minDate" 
                                :max="maxDate" 
                                :first-day-of-week="1" no-title  color="primary">
                            </v-date-picker>
                        </v-col>
                        <v-col cols="12" sm="6" class="slots align-center justify-center">
                            <v-progress-circular v-if="slotsLoading" indeterminate color="primary"></v-progress-circular>
                            <div v-if="slots.length>0 && slotsLoading===false" class="slots-list" max-height="400">
                                <v-btn 
                                    class="btn-slot" 
                                    :dark="currentSlot == slot" 
                                    :class="{ 'primary' : currentSlot == slot }" 
                                    :color="currentSlot == slot ? '' : 'primary'" 
                                    :disabled="slot.can_book != true" block x-large outlined 
                                    v-for="slot in slots" :key="slot.start_at" 
                                    @click="currentSlot = slot">{{slot.start_at | formatTime}} - {{slot.end_at | formatTime}}</v-btn>
                            </div>
                            <v-card v-if="slots.length===0 && slotsLoading===false" class="p-0 no-data d-flex align-center justify-center" outlined elevation="0">
                                <p class="text-center py-2 mb-0">
                                    {{ $page.props.lang.noFreeTimeslots || "No free time slots" }}
                                </p>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="goToReview()" :disabled="currentSlot == null">{{ $page.props.lang.next || "Next" }}</v-btn>
                </v-card-actions>
            </div>
            <div v-if="step == 4" class="review">
                <v-card-text>
                <v-row>
                    <v-col sm="12">
                        <h3 class="mb-1">{{selected.activity.title}}</h3>
                        <ul class="info-data">
                            <li class="pt-1">
                                <v-avatar size="30" class="mr-1"><img :src="selected.appointment.trainer.profile_photo_url+'?w=60'" alt=""></v-avatar>
                                {{selected.appointment.trainer.full_name}} 
                            </li>
                            <li class="pt-1">
                                <v-icon class="mx-1">mdi-calendar-range-outline</v-icon>
                                {{selected.appointment.start | formatDate}}
                            </li>
                            <li class="pt-1">
                                <v-icon class="mx-1">mdi-clock-outline</v-icon>
                                {{selected.appointment.start | formatTime}} - {{selected.appointment.end | formatTime}}
                            </li>
                            <li class="pt-1 pl-1">
                                {{ $page.props.lang.cancelationPolicy || "Cancelation policy" }}: 
                                <b>{{$page.props.settings.cancelation_hours}}</b> 
                                {{ $page.props.lang.hoursBeforeStart || "hours before appointment start" }}
                            </li>
                        </ul>
                    </v-col>
                </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="book()" :loading="bookLoading">
                        {{ $page.props.lang.book || "Book" }}
                    </v-btn>
                </v-card-actions>
            </div>
            </div>
         </v-card>
    </v-dialog>
</template>

<script>
import EventBus from '../../../../eventbus';
import moment from 'moment'

export default {
    props: {
        open: Boolean,
    },
    data() {
        return {
            cancelationLimit: 5,
            modalTitle: this.$page.props.lang.selectActivity || "Select an activity",
            currentTrainer: {},
            trainers: [],
            currentSession: null,
            sessions: [],
            groupAppointments:[],
            classBooking: false,
            step: 1,
            selectedDate: moment().format('YYYY-MM-DD'),
            minDate: moment().format('YYYY-MM-DD'),
            maxDate: moment().add(this.$page.props.settings.future_reservation_days_limit, 'days').format('YYYY-MM-DD'),
            slots: [],
            currentSlot: null,
            slotsLoading: true,
            bookLoading: false,
            isTrainerSessionEmpty: false,
            loadingSessions:false,
            selected: {}
        }
    },
    computed: {
        viewSessionModal: {
            get: function() {
                if(this.open){
                    this.step = 1
                    this.currentTrainer = null
                    this.sessions = []
                }
               
                return this.open
            },
            set: function(newValue) {
                EventBus.$emit('CLOSE_SESSION_MODAL')
                return newValue
            }
        }
    },
    watch: {
        open(value) {
            if (value===false) {
                this.modalTitle = this.$page.props.lang.selectActivity || "Select an activity"
                this.step = 1
            }
        }
    },
    created(){
        this.getActivities();
    },
    methods: {
        getActivities(){
            this.loadingSessions = true;
            this.sessions = [];
            axios.get('/portal/calendar/activities')
                .then((r) => {
                    this.loadingSessions = false;
                    this.sessions = r.data.activities;
                });
        },
        getTrainers(activity_id){
            this.trainers = [];
            this.step = 2

            this.loadingSessions = true;
           
            axios.get('/portal/calendar/trainers/'+activity_id)
                .then((r) => {
                    this.loadingSessions = false;
                    this.trainers = r.data.trainers;
                });
        },
        getGroupAppointments(activity_id){
            this.loadingSessions = true;
            this.groupAppointments = [];
            axios.get('/portal/calendar/group-activities/'+activity_id)
            .then((r) => {
                this.loadingSessions = false;
                this.groupAppointments = r.data.classes;
                this.step = 2;
                this.classBooking = true;
            });

        },
        goToReview(item){
            this.modalTitle = this.$page.props.lang.reviewData || "Review data and book activity"
            if(this.selected.activity.is_session){
                this.selected.appointment.start = this.currentSlot.start_at;
                this.selected.appointment.end = this.currentSlot.end_at;
            }else{
                this.selected.appointment = item;
            }
            this.step = 4;
        },
        selectTrainer(trainer){
            this.selected.appointment = {
                trainer: trainer
            }

            this.modalTitle = this.$page.props.lang.selectTime || "Select a time slot"

            this.step = 3;

            this.getSlots({
                session_id: this.selected.activity.id,
                trainer_id: this.selected.appointment.trainer.id,
                date: moment().format('YYYY-MM-DD')
            })
        },
        goToStep2(activity){

            this.selected.activity = activity;
            if(activity.is_session){

                this.modalTitle = this.$page.props.lang.selectTrainer || "Select a trainer";

                this.classBooking = false;
                this.getTrainers(activity.id);
            }else{

                if(activity.disabled == false){
                    this.modalTitle = this.$page.props.lang.selectAppointment || "Select appointment";
                    this.classBooking = true;
                    this.getGroupAppointments(activity.id)
                }
            }
        },
        goBack(step) {

            if (step===4) {
                if(this.selected.activity.is_session){
                    this.modalTitle = this.$page.props.lang.selectTime || "Select a time";
                    this.step = 3;
                }else{
                    this.modalTitle = this.$page.props.lang.selectAppointment || "Select appointment";
                    this.step = 2;
                }
            }else if(step === 3){
                 this.modalTitle = this.$page.props.lang.selectTrainer || "Select a trainer";
                this.step--;
            } else if (step===2) {
                this.modalTitle = this.$page.props.lang.selectActivity || "Select an activity"
                this.step--
            }
        },
        getSessions(trainer) {
            this.loadingSessions = true;
            this.isTrainerSessionEmpty = false;
            axios.get('/portal/calendar/trainersessions/'+trainer.id)
                .then((r) => {
                    this.loadingSessions = false;
                    if(r.data.status == "OK"){
                        this.sessions = r.data.sessions;
                        if(this.sessions.length == 0){
                            this.isTrainerSessionEmpty = true;
                        }else{
                            this.isTrainerSessionEmpty = false;
                        }
                    }
                })
                .catch((e) => {
                    this.loadingSessions = false;
                    this.isTrainerSessionEmpty = true;
                })
        },
        selectSession(session) {
            this.currentSession = session
            this.step = 2
            this.getSlots({
                session_id: this.currentSession.id,
               // trainer_id: this.currentTrainer.id,
                date: moment().toISOString().substr(0, 10)
            })
            this.modalTitle = this.$page.props.lang.selectTime || "Select a time"
        },
        changeDate() {
            this.currentSlot = null
            this.getSlots({
                session_id: this.selected.activity.id,
                trainer_id: this.selected.appointment.trainer.id,
                date: this.selectedDate
            })
        },
        getSlots(params) {
            this.slotsLoading = true
            axios.get('/portal/calendar/slots', {params: params})
                .then((r) => {
                    this.slots = r.data.slots
                })
                .catch((e) => {

                })
                .then(() => {
                    this.slotsLoading = false
                })
        },
        book() {
            
            if(this.selected.activity.is_session){
                this.bookSession();
            } else {
                this.bookClass(this.selected.appointment.id);
            }
        },
        bookSession() {
            this.bookLoading = true
            axios.post('/portal/calendar/boooksession', {
                    session_id: this.selected.activity.id,
                    trainer_id: this.selected.appointment.trainer.id,
                    date: this.selected.appointment.start
                })
                .then(response => {
                    if (response.data.status==="OK") {
                        this.$inertia.reload({only:['appointments', 'classes']})
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'success',
                            timeout: 5000
                        })
                    } else {
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    }
                    this.viewSessionModal = false
                })
                .catch((e) => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: e.response.data.errors.session[0],
                        color: 'error',
                        timeout: 10000
                    })
                })
                .then(() => {
                    this.bookLoading = false
                })
        },
        bookClass(id){
            this.bookLoading = true;
            axios.post('/portal/calendar/book', {class_id: id})
            .then((r) => {
                let messageType = "success"
                if(r.data.status==="OK"){
                    this.$inertia.reload({only:['appointments', 'classes']})
                    this.viewSessionModal = false;
                     this.bookLoading = false;
                } else {
                    messageType = "error"
                }

                EventBus.$emit('SHOW_NOTIFICATION', {
                        message: r.data.message,
                        color: messageType,
                        timeout: 5000
                });
            })
            .catch((e) =>{
                this.bookLoading = false;

                if(e.response.status == 422){
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: e.response.data.errors.session[0],
                        color: 'error',
                        timeout: 5000
                });
                }
            });
        }
    }
}
</script>